//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Box, Stack, Typography} from '@mui/material';
import Spline from '@splinetool/react-spline';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Layout from 'components/Layout';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
export default function HomePage() {
	return (
		<Layout header={Header} footer={Footer} fillTop fillBottom>
			<Stack id="max-width-box" position="relative" width="100%" maxWidth="1440px" height="100%" alignItems="center">
				<Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1}>
					<Stack width="100%" alignItems="center">
						<Box
							width="100%"
							sx={{
								minHeight: '300px',
								maxHeight: '500px',
								cursor: 'auto',
								'& canvas, & iframe': {
									cursor: 'auto !important',
								},
							}}
						>
							<Spline scene="https://prod.spline.design/ZJ9MQalZRlWZDslX/scene.splinecode" style={{width: '100%', height: '100%'}} />
						</Box>

						<Typography id="meaning" sx={{fontFamily: 'Lora', fontStyle: 'italic', fontSize: 'clamp(18px, 3vw, 24px)'}} color="#0E0E0E">
							{'990 wisdoms, just shy of nirvana.'}
						</Typography>
					</Stack>
				</Box>
			</Stack>
		</Layout>
	);
}
